import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../../../../config.tsx";

/** Загрузка марок автомобилей */
export const carBrandsLoader = createAsyncThunk(
    'laximo/carBrandsLoading',
    async (_, { rejectWithValue }) => {
        return await axios.get(`${API_URL}/car_brands`, { withCredentials: true })
            .then(response => response.data)
            .catch(error => rejectWithValue(error));
    }
);
